import React from 'react';
import './customGridCss.scss';

export default function CustomGrid({ gridValue, gridFields }) {
  return (
    <div>
      <table className="dynamic-table">
        <thead>
          {gridValue?.length > 0 && gridFields && Object.keys(gridFields)?.length >0 && (
            <tr>
              {Object.keys(gridValue[0]).map(header => (
                <th key={header}>{gridFields[header]?.title}</th>
              ))}
            </tr>
          )}
        </thead>
        {gridValue?.length > 0
          && gridValue.map(eachGrid => (
            <>
              {eachGrid && Object.keys(eachGrid).length > 0 && (
                <tbody>
                  <tr>
                    {Object.keys(eachGrid).map(header => (
                      <td key={header}>{eachGrid[header]}</td>
                    ))}
                  </tr>
                </tbody>
              )}
            </>
          ))}
      </table>
    </div>
  );
}
